module.exports = __webpack_public_path__ + "img/4.1.9f78ce4e.svg";